import _ from 'lodash';

function isAcceptedClosedRoute(route) {
  return _(route)
    .get('path')
    .startsWith('accepted/closed');
}

export default isAcceptedClosedRoute;
